import React, { useState } from "react";
import avatar from "../../../../assets/images/news/avatar.jpg";
import copyIcon from "../../../../assets/images/news/copy.svg";
import si1 from "../../../../assets/images/news/si1.svg";
import si2 from "../../../../assets/images/news/si2.svg";
import si3 from "../../../../assets/images/news/si3.svg";
import "./ArticleAuthor.css";

const SOCIAL_LINKS = [
  { icon: si1, label: "Share on X", href: "https://x.com" },
  { icon: si2, label: "Share on Facebook", href: "https://facebook.com" },
  { icon: si3, label: "Share on LinkedIn", href: "https://linkedin.com" },
];

const ArticleAuthor = ({ name, role }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="article-author">
      <div className="article-author__profile">
        <img src={avatar} alt="" className="article-author__avatar" />
        <div className="article-author__info">
          <p className="article-author__name">{name || "Commission of Integrity"}</p>
          <p className="article-author__role">{role || "Official news"}</p>
        </div>
      </div>

      <div className="article-author__actions">
        <button
          type="button"
          className="article-author__copy"
          onClick={handleCopy}
        >
          <img src={copyIcon} alt="" width={20} height={20} />
          <span>{copied ? "Copied!" : "Copy link"}</span>
        </button>

        {SOCIAL_LINKS.map((social) => (
          <a
            key={social.label}
            href={social.href}
            target="_blank"
            rel="noopener noreferrer"
            className="article-author__social"
            aria-label={social.label}
          >
            <img src={social.icon} alt="" width={20} height={20} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default ArticleAuthor;
